import Env from '../base/env';
import Channels from '../base/channels'
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.visual = this.DOM.view.querySelector('.js-visual')
    this.DOM.text = this.DOM.view.querySelector('.js-text')
    //
    this.sizer()
    console.log();

    //! Fns
    setTimeout(() => {
      this.listener()
    }, 50);
    this.funcLaunch = this._fx.bind(this)
    this.channels()
  }

  _fx()
  {
    if(Env.ios == false) {
      this.makeSticky()
    }
  }

  sizer()
  {
    const viewport = Env.framework.toolbox.getViewport()
    const refWidth = (Env.mobileCSS)?viewport.width:viewport.width / 2;
    const DOM = {}
    if(Env.mobileCSS) {
      DOM.img = this.DOM.visual.querySelector('.js-img-mobile')
    } else {
      DOM.img = this.DOM.visual.querySelector('.js-img-desktop')
    }
    const ratio =  DOM.img.getAttribute('height') / DOM.img.getAttribute('width')
    this.DOM.visual.style.minHeight = `${(refWidth) *  ratio}px`
  }

  channels()
  {
    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
  }

  listener()
  {
    this.st = ScrollTrigger.create({
      trigger:this.DOM.visual,
      start:'bottom bottom',
      end:'bottom top',
      markers:false,
      onEnter:()=>{
        if(Env.mobileCSS) {
          Env.$html.classList.add('ui-white')
        }
        Env.$html.classList.remove('cover-exit')
      },
      onEnterBack:()=>{
        if(Env.mobileCSS) {
          Env.$html.classList.add('ui-white')
        }
        Env.$html.classList.remove('cover-exit')
      },
      onLeave:()=>{
        if(Env.mobileCSS) {
          Env.$html.classList.remove('ui-white')
        }
        Env.$html.classList.add('cover-exit')
      },
      onLeaveBack:()=>{
        if(Env.mobileCSS) {
          Env.$html.classList.remove('ui-white')
        }
        Env.$html.classList.add('cover-exit')
      }
    })

    this.stText = ScrollTrigger.create({
      trigger:this.DOM.text,
      start:'top bottom',
      end:'bottom top+=100px',
      markers:false,
      onEnter:()=>{
        if(Env.mobileCSS == false) {
          Env.$html.classList.add('ui-white')
        }
      },
      onEnterBack:()=>{
        if(Env.mobileCSS == false) {
          Env.$html.classList.add('ui-white')
        }
      },
      onLeave:()=>{
        if(Env.mobileCSS == false) {
          Env.$html.classList.remove('ui-white')
        }
      },
      onLeaveBack:()=>{
        if(Env.mobileCSS == false) {
          Env.$html.classList.remove('ui-white')
        }
      }
    })
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view.querySelector('.js-visual'),
      start:'top top',
      pin:true,
      pinSpacing:false,
      end: () => ScrollTrigger.maxScroll(document.body),
      invalidateOnRefresh: true,
    })
  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
    if(typeof this.sticky != 'undefined') {
      this.sticky.kill(true)
    }
    if(typeof this.st != 'undefined') {
      this.st.kill(true)
    }
    if(typeof this.stText != 'undefined') {
      this.stText.kill(true)
    }
  }
}
